import { Experts } from '../../../../config/types/market';

enum ExpertContentType {
  topList = 'toplist',
  guide = 'guide',
  test = 'test',
}

const keyName = (type: string, contentId: string, userId: string) =>
  `expert_click_${type}_${contentId.slice(-15)}${userId.slice(-15)}`;

const request = (
  type: ExpertContentType,
  contentId: string,
  userId: string,
  expertsConfig?: Experts
) => {
  if (!expertsConfig || !expertsConfig.apiUrl) {
    return;
  }

  fetch(
    `${expertsConfig.apiUrl}/clickcounter-${type}/${encodeURIComponent(
      contentId
    )}/${encodeURIComponent(userId)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
    .then(() => {})
    .catch(() => {});
};

const saveTrackedContent = (type: string, id: string, userId: string) => {
  try {
    window.sessionStorage.setItem(keyName(type, id, userId), '1');
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

const hasTrackedContent = (type: string, id: string, userId: string) => {
  /**
   * Only allow track once per session, contentId, userid.
   * Ignore tracking if sessionStorage does not exist
   */
  try {
    return !!window.sessionStorage.getItem(keyName(type, id, userId));
  } catch (e) {
    return true;
  }
};

const likeRequest = (
  type: ExpertContentType,
  contentId: string,
  userId: string,
  expertsConfig?: Experts
) => {
  if (!expertsConfig || !expertsConfig.clickTrackingEnabled) {
    return;
  }

  if (hasTrackedContent(type, contentId, userId)) {
    return;
  }
  saveTrackedContent(type, contentId, userId);
  request(type, contentId, userId, expertsConfig);
};

export const trackExpertList = (
  toplistHeadline: string,
  userId: string,
  expertsConfig?: Experts
) => {
  likeRequest(
    ExpertContentType.topList,
    toplistHeadline,
    userId,
    expertsConfig
  );
};

export const trackExpertGuide = (
  guideId: string,
  userId: string,
  expertsConfig?: Experts
) => {
  likeRequest(ExpertContentType.guide, guideId, userId, expertsConfig);
};

export const trackExpertTest = (
  testId: string,
  userId: string,
  expertsConfig?: Experts
) => {
  likeRequest(ExpertContentType.test, testId, userId, expertsConfig);
};
